var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.loading)?_c('LoadingView'):_c('div',{staticClass:"st-view ticket-view"},[(!_vm.$isMobile)?_c('STNavigationBar',{attrs:{"large":!true,"sticky":false}},[_c('OrganizationLogo',{attrs:{"slot":"left","organization":_vm.organization},slot:"left"})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }